enum HTTP_ERRORS {
  UNAUTHORIZED = 401,
  FORBBIDEN = 403,
}

export default HTTP_ERRORS;
